<template>
  <div class="layout-wrap">
    <Loading />
    <div class="header">
      <div class="header-left-item">
        <div v-if="false" class="menu-btn" @click="menuShow = !menuShow" :class="{'active': menuShow}">
          <!-- 初回リリースでは表示しない -->
          <span class="menu-icon-bar"></span>
          <span class="menu-icon-bar"></span>
          <span class="menu-icon-bar"></span>
        </div>
        <div class="logo"><router-link class="to-top" to="/">蔵衛門クラウド α版</router-link></div>
      </div>
      <div class="header-right-item">
        <!-- TODO 多言語対応するまで表示しない
        <div class="languages">
          <button alt="ja"><flag iso="jp"/></button>
          <button alt="us"><flag iso="us"/></button>
        </div>
        -->
        <div class="account-menu">
          <a class="account-action-button"
             tabindex="0"
             :style="{ backgroundColor: nameToColor(userInfo.user_name) }"
             @click.prevent="accountMenuShow = !accountMenuShow"
             @keyup.enter="accountMenuShow = !accountMenuShow">
             {{ userInfo.user_name.substr(0, 1) }}
          </a>
          <div class="account-menu-detail" v-show="accountMenuShow">
            <div class="account-info-wrap">
              <div class="account-info-icon"
                   :style="{ backgroundColor: nameToColor(userInfo.user_name) }">
                {{ userInfo.user_name.substr(0, 1) }}
              </div>
              <div class="account-info-name">
                {{ userInfo.user_name }}
              </div>
              <div class="account-info-company">
                {{ userInfo.company_name }}
              </div>
            </div>
            <div class="logout-wrap">
              <button class="logout-btn" @click="logout">
                ログアウト
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contents-wrap">
      <div v-if="false" class="menu-wrap" :class="{'menu-show': menuShow, 'menu-hide': !menuShow}">
        <!-- 初回リリースでは表示しない -->
        <div class="menu-back">
          <div class="menu">
            <ul>
              <li><router-link to="/create-kokuban" @click.native="menuShow = false">黒板作成</router-link></li>
              <li><router-link to="/profile" @click.native="menuShow = false">プロフィール</router-link></li>
              <li><router-link to="/payment-and-billing" @click.native="menuShow = false">支払いと請求</router-link></li>
              <li><router-link to="/support-tool" @click.native="menuShow = false">サポートツール</router-link></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content">
        <router-view />
      </div>
    </div>
    <ApiErrorDialog />
  </div>
</template>

<script>
import Vue from 'vue'
import FlagIcon from 'vue-flag-icon'
Vue.use(FlagIcon);
import IconUtils from '@/utils/icon_utils.js'

export default {
  components: {
    ApiErrorDialog: () => import('../ui/ApiErrorDialog.vue'),
    Loading: () => import('../ui/Loading.vue')
  },
  data() {
    return {
      menuShow: false,
      accountMenuShow: false
    }
  },
  methods: { 
    nameToColor(name) {
      return IconUtils.nameToColor(name);
    },
    logout(){
      this.$store.dispatch("api/logoutKuraemonId", {}).then(()=>{
        if (this.$store.getters['api/apiError']) {
          return;
        }
        this.$router.replace({ name: 'login' })
      })
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters['api/result/userInfo'];
    }
  },
}
</script>

<style scoped>
@keyframes menuShow {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes menuHide {
  from {
    opacity: 1;
    transform: translateX(0px);
  }
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
.header {
  background-color: #333;
  color: white;
  padding: 1rem 2rem;
}
.header-left-item {
  display: inline-block;
  width: 60%;
}
.logo {
  display: inline-block;
  vertical-align: middle;
  font-size: 2rem;
  font-weight: bold;
}
.logo .to-top{
  color: white;
  text-decoration: none;
}
.header-right-item {
  width: 40%;
  display: inline-block;
  text-align: right;
}
/* アカウントメニュー */
.account-menu {
  display: inline-block;
  vertical-align: middle;
  margin-left: auto;
  text-align: right;
  position: relative;
}
/* アイコンボタン */
.account-action-button {
  border-radius: 50%;
  color: #FFF;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  outline: none;
  padding: 1rem;
  transition: box-shadow 0.2s;
}
.account-action-button:hover {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
}
.account-action-button:focus {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
}
/* アカウントメニュー詳細 */
.account-menu-detail {
  background-color: #FFF;
  border-radius: 10px;
  border: solid 1px #999;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.3);
  width: 300px;
  position: absolute;
  top: calc(100% + 1rem);
  right: 0;
  z-index: 1010;
}
.account-info-wrap {
  padding: 1rem;
  border-bottom: solid 1px #CCC;
  text-align: center;
}
.account-info-icon {
  display: inline-block;
  border-radius: 50%;
  font-size: 3rem;
  line-height: 1;
  padding: 2rem;
  margin: 1rem;
}
.account-info-name,
.account-info-company {
  color: #333;
}
.logout-wrap {
  padding: 1rem;
  text-align: center;
}
.logout-btn {
  background-color: #FFF;
  border: solid 1px #CCC;
  border-radius: 5px;
  cursor: pointer;
  padding: 0.5rem 2rem;
}
.languages {
  display: inline-block;
  vertical-align: middle;
  margin-left: auto;
  text-align: right;
}
.languages button {
  border: none;
  font-size: 1.4rem;
  padding: 0;
  margin: 0 0.25rem;
  background-color: transparent;
  cursor: pointer;
}
/* メニュー表示ボタン */
.menu-btn {
  display: none;
  cursor: pointer;
  width: 2.5rem;
  height: 2rem;
  margin-right: 1rem;
  position: relative;
  transition: all .3s;
}
.menu-btn::after {
  content: 'MENU';
  display: block;
  font-size: 0.4rem;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  transition: all .3s;
}
.menu-btn.active::after {
  content: 'CLOSE';
}
/* ハンバーガーメニュー */
.menu-icon-bar {
  display: block;
  width: 1.6rem;
  height: 0.2rem;
  margin: 0 auto;
  background-color: white;
  border-radius: 10% / 50%;
  transition: all .3s;
}
.menu-icon-bar + .menu-icon-bar {
  margin-top: 0.3rem;
}
.menu-btn.active .menu-icon-bar:nth-child(1) {
  transform: translateY(0.5rem) rotate(-45deg);
}
.menu-btn.active .menu-icon-bar:nth-child(2) {
  opacity: 0;
}
.menu-btn.active .menu-icon-bar:nth-child(3) {
  transform: translateY(-0.5rem) rotate(45deg);
}
/* メニューとコンテンツを内包 */
.contents-wrap {
  display: flex;
  height: 100%;
}
/* メニューのラップ */
.menu-wrap {
  flex: 1;
  z-index: 15;
}
/* メニューの背景(ドロワー時は黒くなる) */
.menu-back {
  min-height: calc(100vh - 65px);
  height: 100%;
}
/* メニュー */
.menu {
  background-color: lightgray;
  border-right: solid 1px #333;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 1rem;
  height: 100%;
}
ul {
  list-style: none;
  padding: 0;
  margin: 3rem 0;
}
li {
  margin-bottom: 1.2rem;
}
.menu ul li a {
  color: black;
  text-decoration: none;
}
.menu ul li a.router-link-active {
  text-decoration: underline;
}
.content {
  /* 初回リリースではメニュー部分がなくなるので表示域の幅を考慮する */
  /* flex: 5; */
  /* 初回リリース用追加↓ */
  width: 90%;
  max-width: 1024px;
  margin: 0 auto;
}
@media (max-width: 1024px) {
  .header {
    position: fixed;
    width: 100%;
    height: 70px;
    z-index: 20;
  }
  .contents-wrap {
    padding-top: 70px;
  }
  /* メニュー表示ボタンを表示する */
  .menu-btn {
    display: inline-block;
    vertical-align: middle;
  }
  /* コンテンツ部分を横幅100%に */
  .content {
    width: 100%;
  }
  /* フレックス表示で幅を持たせない */
  .menu-wrap {
    flex: 0;
    position: relative;
  }
  /* 画面全体を黒でカバー */
  .menu-back {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  /* メニューを非表示にする */
  .menu-hide {
    visibility: hidden;
    transition: visibility 0.2s;
  }
  /* メニュー表示時のアニメーション */
  .menu-show .menu {
    animation: menuShow 0.2s linear 0s;
  }
  /* メニューを隠すときのアニメーション */
  .menu-hide .menu {
    animation: menuHide 0.2s linear 0s;
  }
  /* カバーの上にメニューを表示 */
  .menu {
    position: absolute;
    overflow-y: auto;
    width: 80%;
    box-shadow: 10px 0 10px 5px rgba(0, 0, 0, 0.2);
  }
}

@media (max-width: 768px) {
  .header-left-item {
    width: 80%;
  }
  .header-right-item {
    width: 20%;
  }
}
</style>